export default __webpack_public_path__ + "assembly01f3d46.png";